// extracted by mini-css-extract-plugin
module.exports = {"promoBanner":"PromoBanner_promoBanner__2MUPv","animated":"PromoBanner_animated__2dGFw","bannerAnimation":"PromoBanner_bannerAnimation__2rBZn","mobile":"PromoBanner_mobile__MgO8W"};